module.exports = __webpack_public_path__ + "img/success.4694b826.svg";